/** Used when REACT_APP_BACKEND_URL is not set in the bundle (avoids assuming localhost:8742 — often no API there). */
const DEFAULT_API = 'https://hppy-rx-api.hppy-ai.com';

/** Base URL for the FastAPI backend (no trailing slash). */
export function getApiBaseUrl() {
  const fromEnv = process.env.REACT_APP_BACKEND_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return String(fromEnv).replace(/\/$/, '');
  }
  return DEFAULT_API;
}
